export default "__VITE_ASSET__Upc63lwv__"